<template>
  <div>
    <div class="note d-block d-md-none" v-if="!preguntaParent.custom_note">
      <div class="color-dark">Todos los participantes / Febrero 2023</div> <div class="n">Margen de error +- 3.1%</div>
    </div>      
    
    <div class="note d-none d-md-block" v-if="!preguntaParent.custom_note">
      <div class="n">Todos los participantes / Febrero 2023 / Margen de error +- 3.1%</div>
    </div>

    <div class="note d-none d-md-block" v-if="preguntaParent.custom_note">
      <div class="n">{{ preguntaParent.custom_note }}</div>
    </div>  
    <div class="note d-block d-md-none" v-if="preguntaParent.custom_note">
      <div class="color-dark">{{ preguntaParent.custom_note.split("/")[0] }} / {{ preguntaParent.custom_note.split("/")[1] }}</div> <div class="n">{{ preguntaParent.custom_note.split("/")[2] }}</div>
    </div>    
  </div>
</template>


<script>
  export default {
    name: "customNote",
    props: {
      preguntaParent: Object
    }
  }
</script>